window.onload = function(){
    setTimeout(function(){
        const root = document.querySelector('#root');
        const header = document.querySelector('body>header')
        console.log('Showing the screen')
        root.style.filter = ''
        root.style.opacity = ''
        root.style.overflow = ''
        root.style.willChange = ''
        if(header){
            header.style.filter = ''
            header.style.opacity = ''
            header.style.overflow = ''
            header.style.willChange = ''
        }
    }, 600)
}


// WEBPACK FOOTER //
// ./src/after_load.js